export default {
      id: "vector-usage",
      viewBox: "0 0 14 20",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#vector-usage",
      toString: function () {
        return this.url;
      }
    }